import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

axios.defaults.baseURL = 'https://api.begin-again.co.kr'

export default new Vuex.Store({
  state: {
    invitationEventCode: '',
    invitationEventSeason: 0,
  },
  mutations: {
    setInvitation (state, invitation) {
      state.invitationEventCode = invitation.invite_code
      state.invitationEventSeason = invitation.season
    },
    clearInvitation (state) {
      state.invitationEventCode = ''
      state.invitationEventSeason = 0
    }
  },
  actions: {
    createInvitation ({ commit }, payload) {
      return axios.post(`/v1/invitations`, payload.params)
    },
  },
  plugins: [createPersistedState()]
})
